<template>
  <div class="login-container">
    <div class="login-background"></div>
    <!-- 新增 SVG 装饰元素 -->
    <svg class="background-svg" viewBox="0 0 1440 320">
      <path
        fill="#ffffff"
        fill-opacity="0.4"
        d="M0,256L48,234.7C96,213,192,171,288,160C384,149,480,171,576,192C672,213,768,235,864,234.7C960,235,1056,213,1152,181.3C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      ></path>
    </svg>
    <div class="login-card">
      <h1 class="platform-title">全景影像扫描项目管理平台</h1>
      <h2>欢迎登录</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">用户名</label>
          <input v-model="username" type="text" id="username" placeholder="请输入用户名" required />
        </div>
        <div class="form-group">
          <label for="password">密码</label>
          <input
            v-model="password"
            type="password"
            id="password"
            placeholder="请输入密码"
            required
          />
        </div>
        <button type="submit" class="login-button">登录</button>
      </form>
      <p class="signup-text"></p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login } from '@/service/PrjInfo'
import { ElMessage } from 'element-plus'

const username = ref('')
const password = ref('')
const router = useRouter()

const handleLogin = async () => {
  if (username.value && password.value) {
    try {
      const response = await login(username.value, password.value)
      localStorage.setItem('token', response.token)
      console.log('登录成功')
      router.push({ name: 'home' })
    } catch (error) {
      ElMessage({
        type: 'error',
        message: `登录失败，请检查用户名和密码`
      })
    }
  } else {
    alert('请输入有效的用户名和密码')
  }
}
</script>

<style scoped lang="scss">
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  /* 使用浅蓝色渐变背景 */
  background: linear-gradient(135deg, #a1c4fd, #c2e9fb);
  position: relative;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* 渐变背景保持和容器一致，并添加模糊效果 */
  background: linear-gradient(135deg, #a1c4fd, #c2e9fb);
  filter: blur(5px);
  z-index: 0;
}

/* SVG 波浪装饰元素 */
.background-svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 1;
}

.login-card {
  width: 450px;
  padding: 40px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  text-align: center;
  animation: slideIn 0.6s ease-in-out;
  z-index: 3;
  .platform-title {
    color: #504f4f;
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: center;
  }
}

@keyframes slideIn {
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
  label {
    font-size: 0.9em;
    color: #555;
    display: block;
    margin-bottom: 5px;
  }
  input {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #ddd;
    font-size: 1em;
    outline: none;
    transition: border-color 0.3s;
    &:focus {
      border-color: #42b983;
    }
  }
}

.login-button {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  background-color: #42b983;
  color: #fff;
  font-size: 1.1em;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover {
    background-color: #36a472;
  }
}

.signup-text {
  margin-top: 15px;
  font-size: 0.9em;
  color: #555;
  a {
    color: #42b983;
    text-decoration: none;
    transition: color 0.3s;
    &:hover {
      color: #36a472;
    }
  }
}
</style>
